import { useState } from 'react';
import { Avatar, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { SmallCheckmark, TrashCanBlackSmall, View } from 'Images';
import { FileViewerDialog } from 'Components';
import { fileToBase64, getFileExtensionFromName } from 'Utils';

interface IFile {
  file: File;
  setFile: (file: File | null) => void;
}

export const File = ({ file, setFile }: IFile) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback);
  const [viewerData, setViewerData] = useState<{
    base64: string;
    fileExtension: string;
  } | null>(null);

  const handleWatchFile = async () => {
    const base64 = await fileToBase64(file);
    const fileExtension = getFileExtensionFromName(file.name);
    setViewerData({ base64, fileExtension });
  };

  return (
    <Stack
      sx={{
        gap: '16px',
        mt: isDesktop ? undefined : '16px',
        maxWidth: isDesktop ? undefined : '100%',
      }}
    >
      <Typography variant={isDesktop ? 'body2' : 'body5'}>
        {dictionary.file}
      </Typography>
      <Stack
        sx={{
          borderRadius: '8px',
          border: '1px solid',
          borderColor: 'primary.shade_200',
          gap: '8px',
          p: '12px 16px',
          flexDirection: 'row',
          alignItems: 'center',
          bgcolor: 'white',
        }}
      >
        <Avatar
          alt=''
          src={SmallCheckmark}
          sx={{ width: '32px', height: '32px' }}
        />
        <Typography sx={{ wordBreak: 'break-word' }} variant='body1'>
          {file.name}
        </Typography>
      </Stack>
      <Stack
        direction={'row'}
        sx={{
          justifyContent: 'end',
        }}
      >
        <Button
          sx={{
            alignSelf: 'flex-end',
            color: 'black',
            gap: '4px',
          }}
          onClick={() => setFile(null)}
        >
          <Avatar
            alt=''
            src={TrashCanBlackSmall}
            sx={{ width: '24px', height: '24px' }}
          />
          <Typography variant='body5'>{dictionary.delete}</Typography>
        </Button>
        <Button
          sx={{
            alignSelf: 'flex-end',
            color: 'black',
            gap: '4px',
          }}
          onClick={handleWatchFile}
        >
          <Avatar alt='' src={View} sx={{ width: '24px', height: '24px' }} />
          <Typography variant='body5'>{dictionary.view}</Typography>
        </Button>
      </Stack>
      {viewerData && (
        <FileViewerDialog
          showDialog={!!viewerData}
          onClose={() => setViewerData(null)}
          base64={viewerData.base64}
          fileExtension={viewerData.fileExtension}
          fileName={file.name}
        />
      )}
    </Stack>
  );
};
